import apiService from '../apiService';

/**
 * Shared Storage admin API (/api/shared-spaces/*).
 *
 * Files inside a space go through the normal fileService with
 * fileableType="shared_space" — there is no separate upload path here.
 *
 * The axios interceptor rewrites uuid → id, so every `id` below is the
 * server-side uuid.
 */
const sharedStorageService = {
  async createSpace(payload) {
    const response = await apiService.post('/shared-spaces', payload);
    return response.data;
  },

  async getSpace(id) {
    const response = await apiService.get(`/shared-spaces/${id}`);
    return response.data;
  },

  async updateSpace(id, payload) {
    const response = await apiService.patch(`/shared-spaces/${id}`, payload);
    return response.data;
  },

  async revokeSpace(id) {
    const response = await apiService.post(`/shared-spaces/${id}/revoke`);
    return response.data;
  },

  async deleteSpace(id) {
    const response = await apiService.delete(`/shared-spaces/${id}`);
    return response.data;
  },

  async getAccessLog(id, page = 1, perPage = 50) {
    const response = await apiService.get(`/shared-spaces/${id}/access-log`, {
      params: { page, per_page: perPage },
    });
    return response.data;
  },

  /** Response carries the plaintext PIN — it is never retrievable again. */
  async addRecipient(spaceId, payload) {
    const response = await apiService.post(`/shared-spaces/${spaceId}/recipients`, payload);
    return response.data;
  },

  /** Change access and end date (OL-167). Link, PIN and open session stay as they are. */
  async updateRecipient(spaceId, recipientId, payload) {
    const response = await apiService.patch(`/shared-spaces/${spaceId}/recipients/${recipientId}`, payload);
    return response.data;
  },

  async sendInvite(spaceId, recipientId) {
    const response = await apiService.post(
      `/shared-spaces/${spaceId}/recipients/${recipientId}/invite`,
    );
    return response.data;
  },

  /** Also returns a one-time plaintext PIN, and kills any open session. */
  async regeneratePin(spaceId, recipientId) {
    const response = await apiService.post(
      `/shared-spaces/${spaceId}/recipients/${recipientId}/regenerate-pin`,
    );
    return response.data;
  },

  /** Back on the same row with a new link and PIN (OL-175). The PIN is shown once. */
  async restoreRecipient(spaceId, recipientId, payload) {
    const response = await apiService.post(
      `/shared-spaces/${spaceId}/recipients/${recipientId}/restore`,
      payload,
    );
    return response.data;
  },

  async revokeRecipient(spaceId, recipientId) {
    const response = await apiService.delete(
      `/shared-spaces/${spaceId}/recipients/${recipientId}`,
    );
    return response.data;
  },
};

export default sharedStorageService;
